/*
 * @Author: Ximen
 * @Date: 2021-03-18 16:26:29
 * @LastEditors: Ximen
 * @LastEditTime: 2021-03-30 14:29:30
 */
import environment from '@/untils/environment';
import apiService from './apiService';

const imgApi = `${environment.imgURL}/statics/json/0`;
const imgApi1 = `${environment.imgURL}/statics/json/`;

const jsonApi = {
  // 获取主营品牌
  shopMainGoods: () => apiService().getJson(`${imgApi}/datadict/shop_main_goods.json`, true),
  // 获取地址
  regionsAll: () => apiService().getJson(`${imgApi1}/regionsAll.json`, true),
  // 获取公司主体
  shopCompanyType: () => apiService().getJson(`${imgApi}/datadict/shop_company_type.json`, true),
  // 获取公司类目
  shopMainCat: () => apiService().getJson(`${imgApi}/datadict/shop_main_cat.json`, true),
  // 获取版本类型设置
  versionTypeConfig: () => apiService().getJson(`${imgApi}/dataconf/version_type_config.json`, true),
};

export default jsonApi;
